(function LivePlannerEndSessionSummary($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerEndSession',
	}, share_form = {
		name: 'LivePlannerShareSession',
	}, share_recipients = [
	], styles =  [
		{
			featureType: "all",
			elementType: "geometry.fill",
			stylers    : [
				{
					weight: "2.00"
				}
			]
		},
		{
			featureType: "all",
			elementType: "geometry.stroke",
			stylers    : [
				{
					color: "#9c9c9c"
				}
			]
		},
		{
			featureType: "all",
			elementType: "labels.text",
			stylers    : [
				{
					visibility: "on"
				}
			]
		},
		{
			featureType: "landscape",
			elementType: "all",
			stylers    : [
				{
					color: "#f2f2f2"
				}
			]
		},
		{
			featureType: "landscape",
			elementType: "geometry.fill",
			stylers    : [
				{
					color: "#ffffff"
				}
			]
		},
		{
			featureType: "landscape.man_made",
			elementType: "geometry.fill",
			stylers    : [
				{
					color: "#ffffff"
				}
			]
		},
		{
			featureType: "poi",
			elementType: "all",
			stylers    : [
				{
					visibility: "off"
				}
			]
		},
		{
			featureType: "road",
			elementType: "all",
			stylers    : [
				{
					saturation: -100
				},
				{
					lightness: 45
				}
			]
		},
		{
			featureType: "road",
			elementType: "geometry.fill",
			stylers    : [
				{
					color: "#eeeeee"
				}
			]
		},
		{
			featureType: "road",
			elementType: "labels.text.fill",
			stylers    : [
				{
					color: "#7b7b7b"
				}
			]
		},
		{
			featureType: "road",
			elementType: "labels.text.stroke",
			stylers    : [
				{
					color: "#ffffff"
				}
			]
		},
		{
			featureType: "road.highway",
			elementType: "all",
			stylers    : [
				{
					visibility: "simplified"
				}
			]
		},
		{
			featureType: "road.arterial",
			elementType: "labels.icon",
			stylers    : [
				{
					visibility: "off"
				}
			]
		},
		{
			featureType: "transit",
			elementType: "all",
			stylers    : [
				{
					visibility: "off"
				}
			]
		},
		{
			featureType: "water",
			elementType: "all",
			stylers    : [
				{
					color: "#46bcec"
				},
				{
					visibility: "on"
				}
			]
		},
		{
			featureType: "water",
			elementType: "geometry.fill",
			stylers    : [
				{
					color: "#c8d7d4"
				}
			]
		},
		{
			featureType: "water",
			elementType: "labels.text.fill",
			stylers    : [
				{
					color: "#070707"
				}
			]
		},
		{
			featureType: "water",
			elementType: "labels.text.stroke",
			stylers    : [
				{
					color: "#ffffff"
				}
			]
		}
	];
	
	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/LivePlanner/endSession/'], function onload()
		{
			Adzuki.Form.registerForm(form);
			Adzuki.Form.registerForm(share_form);

			// Handle Favorite click
			$(".favorite-icon").click(function handleFavorite () {
				let url = '/LivePlanner/endSessionTripFavorite/' + $(this).attr('data-type') + '/' + $(this).attr('data-id') + '/' + $(this).attr('data-session_id');
				if ($(this).hasClass("liked")) {
					$(this).removeClass("liked");
					url += '/false';
				} else {
					$(this).addClass("liked");
					url += '/true';
				}
				Adzuki.Ajax.get(url);
			});
			
			$('#session_export_button').click(function handleExport(e) {
				e.preventDefault();
				
				if ($('#liveplanner_session_id').val() !== '') {
					Adzuki.StatusMessage('Success', 'An email with the requested PDF has been sent to ' + $('#current_client_email_input').val());
					Adzuki.Ajax.get(Adzuki.base_uri + '/LivePlanner/sessionExport/' + $('#liveplanner_session_id').val());
				}
			});
			
			// Export All Trips button clicked
			$('#all_trip_export_button').click(function handleAllTripsExport(e) {
				e.preventDefault();
				
				let items_data = $.map($('.summary_options_table__row'), function mapData(el) {
					let data_value = JSON.parse($(el).attr('data-value'));
					return {
						session_id : data_value.session_id,
						item_id    : data_value.item_id,
						travel_type: data_value.travel_type
					};
				});
				
				let post_data = {
					items_data: items_data,
					session_id: $(this).attr('data-session_id'),
				};
				
				Adzuki.StatusMessage('Success', 'An email with the requested PDF has been sent to ' + $('#current_client_email_input').val() + '.');
				Adzuki.Ajax.post( Adzuki.base_uri + '/LivePlanner/summaryAllTripExport/', post_data);
			});
			
			// Trips export action
			$('.trip_export_button').click(function handleAllTripsExport(e) {
				e.preventDefault();
				let url = Adzuki.base_uri + '/LivePlanner/summaryTripExport/' + $(this).attr('data-item_id') + '/' + $(this).attr('data-session_id') + '/' + $(this).attr('data-travel_type');
				Adzuki.StatusMessage('Success', 'An email with the requested PDF has been sent to ' + $('#current_client_email_input').val() + '.');
				Adzuki.Ajax.get(url);
			});
			
			// End session trips table row clicked
			$('.options_table_clickable').click(function handleClickable() {
				// Disable Clicks
				$('.options_table_clickable').off('click');
				$('.summary_options_table').attr('disabled', true);
				
				let data_value    = JSON.parse($(this).parent().attr('data-value'));
				let $loading_icon = $(this).parent().children('.clickable-loading-icon').eq(0);
				let get_url       = Adzuki.base_uri + '/LivePlanner/endSessionTripSummary/' + data_value.item_id + '/' + data_value.session_id + '/' + data_value.travel_type + '/' + data_value.view_type;
				
				if ($loading_icon.length) {
					$loading_icon.removeClass('hidden');
				}

				Adzuki.Ajax.get(get_url).then(function handleSuccess(response) {
					let modal_identifier = $('#session_trip_modal .modal-content');
					modal_identifier.html(response);
					
					if ($('.fit-map').length !== 0) {
						$('.fit-map').each(function forFitMaps(index, item) {
							let $results_map = $(this),
								results_data = $results_map.data('results'),
								results_map  = ''; // eslint-disable-line no-unused-vars

							results_map = new Adzuki.Map($results_map, {
								zoom  : 10,
								styles: styles,
								init  : function map_init(map) {
									map.populate(results_data.map, true);
									map.drawGuidelines();
									map.map.setZoom(3);
								}
							});
						});
					}
					
					if ($('.fit-builder-carousel-image').length !== 0) {
						// Image carousels
						$('.fit-builder-carousel-image').click(function _showGallery() {
							var component_id  = $(this).data('component-id'),
								controller    = $(this).data('controller'),
								hotel_gallery = null;
							
							Adzuki.Ajax.post('/' + controller + '/galleryImages/' + component_id)
								.then(function sucess(response) {
									var images         = response;
									var gallery_images = [];
									
									if (images.length === 0) {
										return;
									}
									
									$.each(images, function onEachImage(i, image) {
										gallery_images.push({
											src    : image.src,
											thumb  : image.thumb,
											subHtml: image.subHtml,
										});
									});
									
									hotel_gallery = lightGallery($('.fit-builder-carousel-image')[0], {
										licenseKey       : 'github',
										download         : false,
										plugins          : [lgThumbnail],
										dynamic          : true,
										thumbnail        : true,
										toggleThumb      : true,
										allowMediaOverlap: true,
										dynamicEl        : gallery_images,
									});
									
									$('.fit-builder-carousel-image').on('lgAfterClose', function onLgClose(event) {
										$('#session_trip_modal').css('display', 'block');
									});
									
									$('#session_trip_modal').css('display', 'none');
									hotel_gallery.openGallery();
								});
						});
					}
					
					if ($('.ais-carousel-image').length !== 0) {
						// Image carousels
						$('.ais-carousel-image').click(function _showGallery() {
							let hotel_gallery = null;
							let images         = JSON.parse($('#ais-day-carousel-meta-data').val());
							let gallery_images = [];

							if (images.length === 0) {
								return;
							}
							
							$.each(images, function onEachImage(i, image) {
								gallery_images.push({
									src    : image.src,
									thumb  : image.thumb,
									subHtml: image.subHtml,
								});
							});
							
							hotel_gallery = lightGallery($('.ais-carousel-image')[0], {
								licenseKey       : 'github',
								download         : false,
								plugins          : [lgThumbnail],
								dynamic          : true,
								thumbnail        : true,
								toggleThumb      : true,
								allowMediaOverlap: true,
								dynamicEl        : gallery_images,
							});
							
							$('.ais-carousel-image').on('lgAfterClose', function onLgClose(event) {
								$('#session_trip_modal').css('display', 'block');
							});
							
							$('#session_trip_modal').css('display', 'none');
							hotel_gallery.openGallery();
						});
					}

					// modalSessionSummary usage to toggle modals
					if ($('.offer-link').length !== 0) {
						$('.offer-link').click(function offerLinkClicked(e) {
							var $self        = $(this),
								$offer_id    = $self.data("id"),
								$offer_title = $self.data("title");

							e.preventDefault();

							$('#session_trip_modal').modal('hide');
							$('#session_trip_modal').on('hidden.bs.modal', function hideSessionModel(e) {
								Adzuki.Ajax.get('/CruiseSearch/offerDetails/' + $offer_id + '/liveplanner')
									.then(function populateModal(content) {
										$("#modalSessionSummary .modal-dialog").addClass('modal-lg');
										$("#modalSessionSummary .modal-title").text($offer_title);
										$('#modalSessionSummary .modal-body').html(content);
								});
								$('#modalSessionSummary').modal('show');
								$('#modalSessionSummary').on('hidden.bs.modal', function showSessionModel() {
									$('#session_trip_modal').off('hidden.bs.modal');
									$('#session_trip_modal').modal('show');
								});
							});
						});
					}
				}).then(function handleModal() {
					// Enable Clicks
					$loading_icon.addClass('hidden');
					$('.summary_options_table').attr('disabled', false);
					$('.options_table_clickable').on('click', handleClickable);
					
					// Show Modal
					$('#session_trip_modal').modal('show');
					$(document).trigger('trip_summary_modal_open');
				});
			});

			$('.close').on('click', function _closeAttachments(e) {
				e.preventDefault();
				e.stopPropagation();

				$('#modalWindow').modal('hide');
				$('#session_shared_items').modal('hide');
			});
		});
	});
	
	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}
		$('#form-fields').html('<div class="alert alert-success" role="alert">Thank You! Your response has been recorded.</div>');
	};
	
	
	/**
	 * Load function for Share Session Summary form
	 * @param $form
	 */
	share_form.load = function load($form) {
		$('#liveplannersharesession-to').focusout(function _addRecipients() {
			loseFocus($(this).val());
		});

		$('.close-share-session-modal').on('click', function _onCloseModalClick(e) {
			$('#share_session_modal').modal('hide');
		});
	};

	function populateEmailVisualList()
	{
		var html = '', i;
		for (i = 0; i< share_recipients.length; i++) {
			html += '<span class="fit-email-list" data-email="' + share_recipients[i] + '">' + share_recipients[i] + ' <i class="far fa-times-circle"></i></span>';
		}
		$('.email-list-contents').html(html);

		$('#share_session_modal').find('.fit-email-list').on('click', function _removeEmail() {
			var email = $(this).data('email'),
				index = share_recipients.indexOf(email);
			
			if (index !== -1) {
				share_recipients.splice(index, 1);
			}
			
			$('#liveplannersharesession-recipients').val(JSON.stringify(share_recipients));
			
			if (share_recipients.length >= 1) {
				$('.email-list').removeClass('hidden');
				populateEmailVisualList();
			} else {
				$('.email-list').addClass('hidden');
			}
		});
	}
	
	/**
	 *
	 * @param email
	 */
	function loseFocus(email)
	{
		if (email.length > 0) {
			if (Adzuki.String.isEmail(email)) {
				share_recipients.push(email);
				$('#liveplannersharesession-to').val('');
			} else {
				Adzuki.StatusMessage('error', 'Sorry ' + email + ' is not a valid email address');
			}
			
			$('#liveplannersharesession-recipients').val(JSON.stringify(share_recipients));
		}
		
		if (share_recipients.length >= 1) {
			$('.email-list').removeClass('hidden');
			
			populateEmailVisualList();
		} else {
			$('.email-list').addClass('hidden');
		}
	}
}(jQuery, window.Adzuki || {}));
